import { Container } from '@/components/Container';

/* ═══════════════════════════════════════════
   CONECTIVIDADE — Internet, dinheiro e emergências
   Informações práticas para a estadia na ilha
   ═══════════════════════════════════════════ */

export function ConectividadeSection() {
  return (
    <section id="conectividade" className="py-16 sm:py-20 bg-white">
      <Container>
        {/* Header */}
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            Informações práticas
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-2">
            Conectividade e Pagamentos
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            Saiba o que esperar de sinal, caixas eletrônicos e serviços de emergência antes de
            embarcar.
          </p>
        </div>

        {/* Blocos de conteúdo */}
        <div className="grid md:grid-cols-3 gap-5">
          {/* Bloco 1 — Internet e Celular */}
          <div className="bg-sand-50 rounded-2xl border border-sand-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <span role="img" aria-label="Celular" className="text-3xl">
                📱
              </span>
              <h3 className="font-display text-xl text-warm-dark">Internet e Celular</h3>
            </div>
            <ul className="space-y-2.5 font-body text-sm text-warm-gray">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Claro:</strong> melhor cobertura em Nova
                  Brasília, sinal razoável em Encantadas
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Vivo:</strong> cobertura intermitente
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">TIM / Oi:</strong> cobertura muito limitada
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Wi-Fi:</strong> disponível em algumas pousadas
                  — não contar para trabalho remoto
                </span>
              </li>
            </ul>
            <div className="mt-4 bg-teal-50 border border-teal-200 rounded-lg p-3">
              <p className="font-body text-xs text-teal-deep font-semibold">
                Dica: baixe mapas offline (Google Maps ou Maps.me) e playlists antes de embarcar.
              </p>
            </div>
          </div>

          {/* Bloco 2 — Dinheiro e ATM */}
          <div className="bg-sand-50 rounded-2xl border border-sand-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <span role="img" aria-label="Dinheiro" className="text-3xl">
                💵
              </span>
              <h3 className="font-display text-xl text-warm-dark">Dinheiro e ATM</h3>
            </div>
            <ul className="space-y-2.5 font-body text-sm text-warm-gray">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-coral mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">ATM:</strong> Bradesco em Nova Brasília, limite
                  de saque baixo (~R$300–500/transação)
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-coral mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Encantadas:</strong> sem banco e sem ATM
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-coral mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Recomendação:</strong> saque ao menos
                  R$150–200/pessoa/dia antes de embarcar
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-coral mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Aceita cartão:</strong> pousadas geralmente
                  sim; restaurantes menores e vendedores de praia, somente dinheiro
                </span>
              </li>
            </ul>
          </div>

          {/* Bloco 3 — Emergências */}
          <div className="bg-sand-50 rounded-2xl border border-sand-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <span role="img" aria-label="Emergência" className="text-3xl">
                🆘
              </span>
              <h3 className="font-display text-xl text-warm-dark">Emergências</h3>
            </div>
            <ul className="space-y-2.5 font-body text-sm text-warm-gray">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Bombeiros:</strong> (41) 193
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">SAMU:</strong> 192
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Guarda Ambiental Ilha do Mel:</strong>{' '}
                  {/* TODO: confirmar número correto com Josirley */}
                  confirmar número
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                <span>
                  <strong className="text-warm-dark">Posto de Saúde Nova Brasília:</strong>{' '}
                  {/* TODO: confirmar número e horário com Josirley */}
                  horário comercial (confirmar número)
                </span>
              </li>
            </ul>
            <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-3">
              <p className="font-body text-xs text-amber-700 font-semibold">
                Salve os números de emergência no celular ANTES de embarcar — o sinal pode falhar
                quando você mais precisar.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
